var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTdLogoOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 390.619,
    height: 46.836,
    viewBox: "0 0 390.619 46.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#08adac}.cls-3{fill:#134067}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    transform: "translate(355.396 -353.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    transform: "translate(-355.396 353.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    transform: "translate(37.149 .043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    fill: "#08aaa8",
    d: "M-308.409 400.226l-23.533-23.394 23.533-23.4 5.583 5.613-17.884 17.786 17.885 17.784z",
    transform: "translate(331.942 -353.433)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    transform: "translate(66.891 .036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    d: "M-307.581 400.228l-5.583-5.615 17.885-17.784-17.885-17.786 5.583-5.615 23.535 23.405z",
    className: "cls-2",
    transform: "translate(313.164 -353.429)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    d: "M-331.862 400.2l-23.534-23.4 23.534-23.4 5.583 5.615-17.893 17.784 17.9 17.779z",
    className: "cls-3",
    transform: "translate(355.396 -353.408)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    transform: "translate(29.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    d: "M-331.035 400.205l-5.583-5.615 17.885-17.784-17.885-17.786 5.583-5.615 23.532 23.4z",
    className: "cls-3",
    transform: "translate(336.618 -353.406)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    transform: "translate(37.164 17.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_883",
    d: "M0 0H7.918V33.164H0z",
    className: "cls-2",
    transform: "rotate(-45.17 6.75 2.809)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    transform: "translate(-253.716 360.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M-279.7 364.43h-11.5v-6.274h30.321v6.274h-11.5v27.6h-7.321z",
    className: "cls-3",
    transform: "translate(291.2 -357.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M-270.343 363.234h6.9v5.018c.732-2.143 3.4-5.541 9.149-5.541v7.633c-6.065 0-9.044 2.77-9.044 8.992v10.036h-7.006z",
    className: "cls-3",
    transform: "translate(303.378 -354.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M-258.035 378.672v-15.631h7.006v14.689c0 3.66 1.568 5.333 4.809 5.333 3.66 0 5.438-3.085 5.438-6.64v-13.382h7.006v26.137h-6.587v-3.658c-1.568 2.563-5.122 4.183-8.155 4.183-7.217-.003-9.517-4.236-9.517-11.031z",
    className: "cls-3",
    transform: "translate(310.565 -354.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M-240.215 386.34l2.509-5.385a12.649 12.649 0 0 0 8.155 2.772c1.62 0 4.288-.627 4.288-2.2s-2.249-1.934-4.5-2.561c-5.175-1.361-9.41-3.085-9.41-8.1 0-5.333 5.228-8.156 10.142-8.156a17.83 17.83 0 0 1 9.724 2.613l-2.352 5.228a16.409 16.409 0 0 0-7.267-1.831c-1.62 0-3.136.733-3.136 1.831 0 1.464 2.2 1.934 4.6 2.457 4.444 1.045 9.305 2.979 9.305 8.312 0 6.431-6.535 8.574-11.4 8.574-5.588.006-9.194-2.194-10.658-3.554z",
    className: "cls-3",
    transform: "translate(320.97 -354.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M-221.12 383.19v-12.076h-3.816v-5.645h3.816v-5.018l7.006-1.57v6.587h7.215v5.645h-7.215v11.973c0 2.248 1.1 2.979 2.352 2.979a6.416 6.416 0 0 0 3.347-1.1l1.986 5.175a12.054 12.054 0 0 1-6.64 1.988c-5.231.003-8.051-3.028-8.051-8.938z",
    className: "cls-3",
    transform: "translate(329.891 -357.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M-211.67 376.3a13.423 13.423 0 0 1 13.539-13.591c7.11 0 12.7 6.065 12.7 13.487a23.429 23.429 0 0 1-.155 2.51h-18.974c.836 3.607 3.816 5.331 7.267 5.331a12.97 12.97 0 0 0 7.056-2.037l2.613 5.018a17.608 17.608 0 0 1-9.722 2.876c-7.632.006-14.324-4.966-14.324-13.594zm19.656-2.248a6.313 6.313 0 0 0-6.325-5.488 6.552 6.552 0 0 0-6.326 5.488z",
    className: "cls-3",
    transform: "translate(337.637 -354.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M-192.7 379.155c0-7.527 4.706-13.591 11.92-13.591a10.285 10.285 0 0 1 7.893 3.45v-11.188h7.006v34.4h-6.64v-3.136c-1.882 2.509-5.227 3.66-8.363 3.66-7.21-.002-11.816-6.067-11.816-13.595zm19.813 0c0-4.077-2.613-7.109-6.22-7.109-3.765 0-6.483 3.032-6.483 7.109 0 4.129 2.718 7.11 6.483 7.11 3.607 0 6.225-2.927 6.225-7.11z",
    className: "cls-3",
    transform: "translate(348.717 -357.826)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    transform: "translate(-58.531 359.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M-167.969 357.171h14c11.471 0 18.685 7.916 18.685 17.448s-7.215 17.445-18.685 17.445h-14zm13.679 28.429c6.676 0 11.092-4.631 11.092-10.984 0-6.3-4.416-10.986-11.092-10.986h-6.139v21.97z",
    className: "cls-2",
    transform: "translate(167.969 -357.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M-144.713 375.863a13.826 13.826 0 0 1 13.946-14c7.322 0 13.085 6.247 13.085 13.892a23.883 23.883 0 0 1-.162 2.585h-19.547c.862 3.716 3.931 5.491 7.485 5.491a13.361 13.361 0 0 0 7.27-2.1l2.691 5.168a18.135 18.135 0 0 1-10.015 2.962c-7.86.002-14.753-5.112-14.753-13.998zm20.245-2.316a6.5 6.5 0 0 0-6.515-5.654 6.752 6.752 0 0 0-6.516 5.654z",
    className: "cls-2",
    transform: "translate(181.548 -354.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M-126.659 362.2h7.215l5.008 13.839c1.023 2.8 1.885 5.6 1.993 5.978.054-.377.969-3.285 1.939-5.924l5.004-13.893h7.161l-10.607 26.977h-7.109z",
    className: "cls-2",
    transform: "translate(192.09 -354.233)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdLogoOriginal);
export default __webpack_public_path__ + "static/media/td-logo-original.b1fd7431.svg";
export { ForwardRef as ReactComponent };